const constants = {
  APPEND: {
    INACTIVE: ' (Inactive)'
  },
  ATS: {
    HQ: {
      COORDS: {
        LAT: 30.2341727,
        LNG: -97.8143139
      }
    },
    DEFAULT: {
      COUNTRY: 'United States',
      STATE: 'TX',
      TIMEZONE: 'America/Chicago'
    },
    EXCLUDE_HOLIDAYS: [  // date-picker-js provides a list of 14 observable holidays in Texas. This is the sub-list of Holidays NOT observed by ATS to exclude from that list.
      "Martin Luther King Jr. Day",
      "Presidents' Day",
      "Juneteenth",
      "Columbus Day",
      "Veterans Day",
      "Day after Christmas"
    ]
  },
  VEE_VALIDATE: {
    CONFIG: {
      delay: 250 // prevents premature validation which causes error to flash on screen
    }
  },
  FLEXMONSTER: {
    LOCAL_STORAGE_KEY: 'flexmonsterIndex'
  },
  RETURN_CODES: {
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR'
  },
  NOTIFY: {
    SUCCESS: 'success',
    ERROR: 'error', // backend only, not a vue notify option
    DANGER: 'danger',
    WARNING: 'warning'
  },
  STATUSES: {
    ENABLED: 'Enabled',
    DISABLED: 'Disabled',
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    CANCELLED: 'Cancelled',
    COMPLETED: 'Completed',
    ON_HOLD: 'On Hold',
    BLOCKED: 'Blocked',
    PENDING: 'Pending',
    IN_PROGRESS: 'In Progress',
    ERROR: 'Error'
  },
  STATUSES_LIST: [
    {
      value: 'Enabled',
      label: 'Enabled'
    },
    {
      value: 'Disabled',
      label: 'Disabled'
    }
  ],
  HEALTH_CHECK_STATUSES: {
    ERROR: 'error',
    LOADING: 'loading',
    DOWN: 'down',
    UP: 'up'
  },
  PRIORITIES: {
    VERY_HIGH: {
      LABEL: 'Very High',
      VALUE: '100'
    },
    HIGH: {
      LABEL: 'High',
      VALUE: '80'
    },
    MEDIUM: {
      LABEL: 'Medium',
      VALUE: '60'
    },
    LOW: {
      LABEL: 'Low',
      VALUE: '40'
    },
    VERY_LOW: {
      LABEL: 'Very Low',
      VALUE: '20'
    }
  },
  TYPES: {
    RESIDENTIAL: 'Residential',
    COMMERCIAL: 'Commercial',
    MILITARY: 'Military'
  },
  CONFIGS: {
    GOOGLE_MAPS_API_KEY: 'GOOGLE_MAPS_API_KEY',
    ELASTICSEARCH_UN_PW: 'ELASTICSEARCH_UN_PW'
  },
  USER_PREFERENCE_TYPES: {
    GLOBAL: 'global',
    MY_TASKS: 'myTasks',
    SEARCH_TASKS: 'searchTasks',
    INSPECTIONS_ROUTING: 'inspectionsRouting',
    INVOICE_TASKS: 'invoiceTasks',
    SEARCH_JOBS: 'searchJobs',
    JOBS_BY_DEPARTMENT: 'jobsByDepartment',
    PRICE_RULES: 'priceRules',
    IDA_ARCHIVE: 'idaArchive'
  },
  ADVANCED_USER_PREFERENCE_TYPES: {
    MY_TASKS: 'myTasks',
    SEARCH_TASKS: 'searchTasks',
    INSPECTIONS_ROUTING: 'inspectionsRouting',
    INVOICE_TASKS: 'invoiceTasks',
    SEARCH_JOBS: 'searchJobs',
    JOBS_BY_DEPARTMENT: 'jobsByDepartment'
  },
  REGEX: {
    PO_REGEX: /^[a-zA-Z0-9]([\-a-zA-Z0-9_.\/ ]{0,23}[a-zA-Z0-9])?$/
  },
  ROUTING_TABLE_FORMATS: {
    BY_INSPECTOR: { value: "groupByInspector", label: "By Inspector", componentName: "TableByInspector" },
    BY_PROJECT: { value: "groupByProject", label: "By Project", componentName: "TableByProject" },
    CUSTOM: { value: "userPreferences", label: "Custom", componentName: "CustomTable" }
  },
  LOG_LEVELS: {
    DEBUG: 'debug',
    INFO: 'info',
    WARN: 'warn',
    ERROR: 'error',
    FATAL: 'fatal'
  },
  DATA_TYPES: {
    STRING: 'string',
    BOOLEAN: 'boolean',
    NUMBER: 'number'
  },
  INSPECTION_RESULTS: {
    CANCELLED: 'Cancelled',
    COMPLETED: 'Completed',
    CORRECT_AND_PROCEED: 'Correct and Proceed',
    FAILED: 'Failed',
    PARTIAL_PASS: 'Partial Pass',
    PASSED: 'Passed',
    TRIP_CHARGE: 'Trip Charge'
  },
  CAMUNDA: {
    ACTIVITY_TYPES: {
      USER_TASK: 'userTask',
      INCLUSIVE_GATEWAY: 'inclusiveGateway',
      PARALLEL_GATEWAY: 'parallelGateway',
      INTERMEDIATE_TIMER: 'intermediateTimer',
      SUB_PROCESS: 'subProcess'
    }
  },
  COMPANY: {
    TYPES: {
      BUILDER: 'Builder',
      CLIENT: 'Client',
      CONSULTANT: 'Consultant',
      JURISDICTION: 'Jurisdiction'
    }
  },
  ESCAPE_KEY: 27,
  HEADERS: {
    DEFAULT: {
      headers: {
        'Content-Type': 'application/json'
      }
    },
    CAMUNDA_UPLOAD: {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    },
    FORM_DATA: {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    },
    FILE_MANAGER_API: {
      headers: {}
    },
    FILE_DOWNLOAD: {
      responseType: 'arraybuffer',
      headers: {}
    },
    XML: {
      headers: {
        'Content-Type': 'application/XML'
      }
    },
    PATCH: {
      headers: {
        'Content-Type': 'application/json-patch+json'
      }
    },
    MERGE_PATCH: {
      headers: {
        'Content-Type': 'application/merge-patch+json'
      }
    },
    USERS_API: {
      headers: {
        'Content-Type': 'application/json'
      }
    },
    HTTP_PROXY_API: {
      headers: {
        'Content-Type': 'application/json'
      }
    },
    INSPECTION_RESULTS_API: {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  },
  MOMENT: {
    DAYS: {
      SUNDAY: 0,
      MONDAY: 1,
      TUESDAY: 2,
      WEDNESDAY: 3,
      THURSDAY: 4,
      FRIDAY: 5,
      SATURDAY: 6
    }
  },
  DATE: {
    FORMAT: {
      DISPLAY: 'MM-dd-yyyy',
      VALUE: 'yyyy-MM-dd'
    },
    URL_FORMAT: {
      DISPLAY: 'MM-dd-yyyy',
      VALUE: 'yyyy/MM/dd',
      DAYJS: 'YYYY/MM/DD'
    }
  },
  DATETIME: {
    END_OF_DAY: {
      DISPLAY: 'MM-dd-yyyy',
      VALUE: 'yyyy-MM-ddTHH:mm:ssZZ'
    },
    URL_FORMAT: {
      DISPLAY: 'MM-dd-yyyy',
      VALUE: 'yyyy/MM/dd HH:mm:ssZZ',
      DAYJS: 'YYYY/MM/DD HH:mm:ssZZ'
    }
  },
  TIME: {
    MILLIS: {
      TEN_MINUTES: 60000 * 10,
      FIVE_MINUTES: 60000 * 5,
      ONE_MINUTE: 60000,
      TENTH_SECOND: 100,
      QUARTER_SECOND: 250,
      THIRD_SECOND: 333,
      HALF_SECOND: 500,
      ONE_SECOND: 1000,
      TWO_SECONDS: 1000 * 2,
      THREE_SECONDS: 1000 * 3,
      FOUR_SECONDS: 1000 * 4,
      FIVE_SECONDS: 1000 * 5,
      TEN_SECONDS: 1000 * 10
    },
    SECONDS: {
      ONE: 1,
      TWO: 2,
      THREE: 3,
      FOUR: 4,
      FIVE: 5,
      TEN: 10,
      SIXTY: 60
    },
    ONE_HOUR: 1000 * 60 * 60,
    ONE_DAY: 3600 * 1000 * 24,
    ONE_WEEK: 3600 * 1000 * 24 * 7
  },
  FILE_SIZE: {
    TEN_MB: 1024 * 1024 * 10
  },
  LOCAL_STORAGE: {
    EXPIRATION: { // in hours
      ONE_DAY: 24,
      ONE_MONTH: 24 * 30
    },
    LOCATION: {
      ALL_USER_PREFERENCES: 'allUserPreferences',
      PRIORITIES_DATA: 'PrioritiesData',
      STATUS_DATA: 'StatusData',
      TASK_NAMES: 'taskNames',
      TASK_TEMPLATES: 'taskTemplates',
      USER_DATA: 'userData',
      USER_MAP_DATA: 'userMapData'
    },
    SET_TIME: 'SetTime'
  },
  GROUPS: {
    ADMIN_USERS: 'Admin Users',
    ADVANCED_USERS: 'Advanced Users',
    CODE_INSPECTORS: 'Code Inspectors',
    ENERGY_INSPECTORS: 'Energy Inspectors',
    GPS_USERS: 'GSP Users',
    INSPECTION_ROUTERS: 'Inspection Routers',
    POWER_USERS: 'Power Users',
    STANDARD_USERS: 'Standard Users',
    SUPER_USERS: 'Super Users',
    IDA_USERS: 'IDA Users',
  },
  DEPARTMENTS: {
    SURVEY: 'Survey',
    INSPECTIONS: 'Inspections',
    ENERGY: 'Energy',
    INFORMATION_TECHNOLOGY: 'Information Technology'
  },
  ERROR_TYPES: {
    AXIOS: 'axios',
    AXIOS_TIMEOUT: 'ECONNABORTED',
    FILE_UPLOAD: 'fileUpload',
    GENERAL: 'general'
  },
  AUTOCOMPLETE: {
    TRIGGER_LENGTH: 2,
    STREET_CHAR_LENGTH: 3
  },
  JURISDICTIONS: [
    {value: 'In Jurisdiction', label: 'In Jurisdiction'},
    {value: 'In ETJ', label: 'In ETJ'},
    {value: 'In County', label: 'In County'}
  ],
  FOLDERS: {
    COMPANIES: 'companies',
    INSPECTION_FORMS: 'inspection-forms',
    FLOOR_PLANS: 'floor-plans',
    ENERGY_PLANS: 'energy-plans',
    PROJECTS: 'projects',
    USERS: 'users'
  },
  COMPONENTS: {
    CHECKBOX: 'Checkbox',
    CURRENCY: 'Currency',
    DATE: 'Date',
    HTML: 'HTML',
    INPUT: 'Input',
    FILE: 'File',
    NUMERIC: 'Numeric',
    SWITCH: 'PSwitch',
    RADIO: 'Radio',
    SELECT: 'Select',
    SELECT_MULTIPLE: 'SelectMultiple',
    TAGS: 'Tags',
    TIME_PICKER: 'TimePicker',
    TIME_SELECT: 'TimeSelect',
    TIME_TRACKING: 'TimeTracking',
    TIME_TRACKING_SELECT: 'TimeTrackingSelect'
  },
  COMPANY_TYPES: {
    BUILDER: 'Builder',
    CLIENT: 'Client',
    JURISDICTION: 'Jurisdiction',
    CONSULTANT: 'Consultant'
  },
  ENTITY_TYPES: {
    COMPANY: 'Company',
    PROJECT: 'Project',
    JOB: 'Job',
    TASK: 'Task',
    USER: 'User'
  },
  ENTITY_FIELDS: {
    PLAN_NAME: {
      CLASS: 'com.ats.ptrac.entity.PlanName'
    },
    PROJECT:{
      PROJECTS: 'projects',
      CLASS: 'com.ats.ptrac.entity.Project',
      METADATA: 'metadata',
      CREATED_AT: 'createdAt'
    },
    JOB: {
      JOBS: 'jobs',
      CLASS: 'com.ats.ptrac.entity.Job',
      DATE_RECEIVED: 'dateReceived',
      TARGET_COMPLETION_DATE: 'targetCompletionDate'
    },
    TASK: {
      TASKS: 'tasks',
      CLASS: 'com.ats.ptrac.entity.PtracTask',
      COMPLETION_DATE: 'completionDate',
      CREATED_AT: 'createdAt',
      DUE_DATE: 'dueDate',
      ASSIGNEE_ID: 'assigneeId',
      CLIENT_ID: 'clientId',
      STATUS: 'status',
      FIELD_VALUES: {
        QB_ITEM_DESCRIPTION: 'qbItemDescription',
        PO_NUMBER: 'poNumber',
        REINSPECTION: 'reinspection',
        PRICE: 'price',
        TRAVEL_CHARGE: 'travelCharge'
      }
    },
    JOB_TEMPLATE: {
      CLASS: 'com.ats.ptrac.entity.JobTemplate'
    },
    PRICE_RULES: {
      EXPIRY: "expiry",
      CREATED_AT: "createdAt",
      UPDATED_AT: "updatedAt"
    }
  },
  ENTITIES: {
    CAMUNDA_DEPLOYMENT: 'CamundaDeployment',
    CITY: 'City',
    COMMENT: 'Comment',
    COMMUNITY: "Community",
    COMPANY: 'Company',
    PTRAC_FILE: 'PtracFile',
    FORM_FIELD_BLOCK: 'FormFieldBlock',
    INVOICE: 'Invoice',
    ITEM_CODE: 'ItemCode',
    JOB: 'Job',
    JOB_TEMPLATE: 'JobTemplate',
    LEGAL_SUBDIVISION: 'LegalSubdivision',
    METADATUM: 'Metadatum',
    PLAN_NAME: 'PlanName',
    PRICE_RULE: 'PriceRule',
    PROJECT: 'Project',
    SERVICE_AREA: 'ServiceArea',
    STREET:'Street',
    TAG: 'Tag',
    TASK: 'PtracTask',
    PTRAC_TASK: 'PtracTask',
    TASK_NAME: 'TaskName',
    TASK_TEMPLATE: 'TaskTemplate',
    USER: 'User'
  },
  ENTITY_ENDPOINTS: {
    DIGITAL_FORMS_V2: 'digital-forms-v2',
    CITIES: 'cities',
    COMMUNITIES: 'communities',
    COMPANIES: 'companies',
    LEGAL_SUBDIVISIONS: 'legal-subdivisions',
    STREETS: 'streets',
    PRICE_RULES: 'price-rules',
    PROJECTS: 'projects',
    JOBS: 'jobs',
    JOB_TEMPLATES: 'job-templates',
    TAGS: 'tags',
    TASKS: 'tasks',
    USERS: 'users'
  },
  INVOICE_BY: {
    JOB: 'job',
    TASK: 'task',
    MULTIPLE_TASKS: 'multipleTasks'
  },
  QUICKBOOKS: {
    AR_ACCOUNT: 'Receivables 2',
    TRAVEL_CHARGE: {
      ITEM_CODE: 'tc',
      CLASS: 'inspections',
      DESCRIPTION: 'Travel Charge'
    },
    CLASSES: [
      'admin',
      'civil',
      'Energy',
      'inspections',
      'inspections:Commercial',
      'mep',
      'Plan Review',
      'structural',
      'surveying'
    ]
  },
  ELASTICSEARCH: {
    UN_PW: null,
    MAX_SEARCH_RESULTS: 10000,
    BIG_DATA_RESULTS_THRESHOLD: 1000,
    MAX_SEARCH_RESULTS_INVOICE_TASKS: 500,
  },
  PTRAC_MAX_SEARCH_RESULTS: 10000,
  DO_NOT_DISPLAY_PRICE_VALUE: -1000,
  TASKS: {
    TEMPLATE: {
      KEYS: {
        INTERIOR_ELEVATION_INSPECTION: 'interiorElevationInspection',
        FINAL_GRADE_INSPECTION: 'finalGradeInspection'
      }
    },
    NAMES: {
      INVOICE: 'Invoice',
      INVOICE_SUBMITTAL: 'Invoice Submittal',
      WINDBRACE_INSPECTION: 'Windbrace Inspection'
    },
    CAMUNDA: {
      INVOICE_SUBMITTAL_1: 'invoiceSubmittal_1'
    }
  },
  EXCEL: {
    DATA_TYPE: {
      STRING: 'string',
      NUMBER: 'number'
    }
  },
  TRAVEL_CHARGE: {
    STATES: {
      UNDECIDED: 'PRICE_RULE_UNDECIDED',
    }
  },
  SEARCH_SCORE_THRESHOLD: 0.5,
  ENVIRONMENTS: {
    DEVELOPMENT: 'development',
    STAGING: 'staging',
    PRODUCTION: 'production'
  },
  MESSAGES: {
    ASSIGNEE_NOT_SELECTED: 'Please select an assignee from the search results.',
    CITY_NOT_SELECTED: 'Please select a city from the search results.',
    STREET_NAME_NOT_SELECTED: 'Please select a street name from the search results.',
    AT_LEAST_ONE_FIELD_REQUIRED: 'At least one search field is required'
  },
  ENDPOINTS: {
    WELL_KNOWN: '/.well-known/openid-configuration'
  },
  INDEX_COLUMN_WIDTHS: {
    WIDE: '65px',
    NARROW: '55px'
  },
  CREATE_PROJECT: {
    FROM_PROJECT_SEARCH: 'projectSearch',
    FROM_PROJECT_SEARCH_WIZARD: 'projectSearchWizard'
  },
  PROJECT_FIELDS: {
    ZIP: 'zip',
    COUNTY: 'county',
    CITY: 'city',
    STREET_NAME: 'streetName',
    LEGAL_SUBDIVISION: 'legalSubdivision',
    LEGAL_SUBDIVISION_ID: 'legalSubdivisionId',
    SEARCH: 'search',
    PROJECT_TYPE: 'projectType'
  },
  SUPPLYPRO: {
    PO_TYPES: {
      ORIGINAL: 'Original',
      CANCELLATION: 'Cancellation',
      RESCHEDULE: 'Reschedule',
      CHANGE: 'Change',
      REINSPECTION: 'Reinspection',
      UNKNOWN: 'Unknown'
    },
    PROJECT_FIELDS: {
      CITY: 'city',
      STREET: 'street',
      STATE: 'state',
      STATE_CODE: 'stateCode',
      ZIP_CODE: 'zipCode',
      POSTAL_CODE: 'postalCode',
      SUBDIVISION: 'subdivision',
      LOT: 'lot',
      BLOCK: 'block',
      PHASE: 'phase'
    },
    JOB_FIELDS: {
      JOB_NUM: 'jobNum',
      ELEVATION: 'elevation',
      BUILDER_NAME: 'builderName',
      PRIMARY_NAME: 'primaryName',
      PRIMARY_FIRST_NAME: 'primaryFirstName',
      PRIMARY_LAST_NAME: 'primaryLastName',
      PRIMARY_PHONE_NUMBER: 'primaryPhoneNumber',
      PRIMARY_EMAIL_ADDRESS: 'primaryEmailAddress',
      START_DATE: 'startDate',
      END_DATE: 'endDate',
      BUYER_STATUS: 'buyerStatus',
      ORDER_HEADER_NOTE: 'orderHeaderNote',
      ISSUE_DATE: 'issueDate',
      ORDER_TYPE: 'orderType',
      PERMIT_NUMBER: 'permitNumber',
      COMMUNITY_ID: 'communityId',
      SUBDIVISION: 'subdivision'
    }
  },
  SORT_PROPS: {
    NUMBER_IN_STRING: ['buildingNumber', 'streetNumber', 'floorNumber', 'suiteNumber', 'poNumber', 'elevation', 'number', 'permitNumber'],
    NUMBER: ['price', 'travelCharge', 'priority', 'hourlyRate'],
    DATE: 'date',
    FIELD_VALUES: 'fieldValues',
    ADDRESS: 'address'
  },
  INSPECTOR_ROUTING: {
    SOLVER_STATUS: {
      NOT_SOLVING: "NOT_SOLVING",
      PREPARING: "PREPARING",
      SOLVING: "SOLVING_ACTIVE",
      PROCESSING: "PROCESSING",
      LOADING_TABLES: "LOADING_TABLES"
    },
    UNASSIGNED: {
      LABEL: "! Unassigned",
      VALUE: "!assigned"
    }
  },
  IDA: {
    INSPECTION_RESULTS: [
      'Performed',
      'Not Cancelled',
      'Approved',
      'Cancelled',
      'Completed',
      'Correct and Proceed',
      'Failed',
      'Incomplete',
      'Partial Passed',
      'Passed',
      'Reinspect required',
      'Trip charge'
    ],
    INSPECTION_TYPES: [
      '2009 IECC Final Inspection',
      '2009 IECC Final Reinspection',
      '2009 IECC Inspection',
      '2009 IECC Reinspection',
      '2009 IECC Rough Inspection',
      '2009 IECC Rough Reinspection',
      '2012 Energy Final Inspection',
      '2012 Energy Final Reinspection',
      '2012 Energy Rough Inspection',
      '2012 Energy Rough Reinspection',
      '2015 Energy Final Inspection',
      '2015 Energy Final Reinspection',
      '2015 Energy Rough Inspection',
      '2015 Energy Rough Reinspection',
      '2nds-Frame/MEP Inspection',
      'ADA Sidewalk Inspection',
      'ADA Sidewalk Reinspection',
      'Antero Interior Elevation Inspection',
      'Antero Interior Elevation Reinspection',
      'Armadillo Interior Elevation Inspection',
      'Attic Ventilation Calculation',
      'Blower Door Inspection',
      'Blower Door Reinspection',
      'Bonded Builder Final',
      'Bonded Builder Final Grade',
      'Bonded Builder Final Grade Reinspection',
      'Bonded Builder Final Reinspection',
      'Bonded Builder Frame Inspection',
      'Bonded Builder Frame Reinspection',
      'Brohn Homes Interior Elevation Inspection',
      'Buffington Interior Elevation Inspection',
      'Buffington Interior Elevation Reinspection',
      'Buffington QA Inspection',
      'Buffington QA Reinspection',
      'Building Envelope Inspection',
      'Building Finish Inspection',
      'COA Final Energy Inspection',
      'COA Final Energy Reinspection',
      'COA Rough Energy Inspection',
      'COA Rough Energy Reinspection',
      'Certificate of Occupancy Inspection',
      'Cheldan Interior Elevation Inspection',
      'Chesmar Interior Elevation Inspection',
      'Chesmar Interior Elevation Reinspection',
      'City of Buda Certificate of Occupancy',
      'City of Buda Commercial Site Final Inspection',
      'City of Buda Copper Inspection',
      'City of Buda Copper Reinspection',
      'City of Buda Electrical Meter',
      'City of Buda Final Inspection',
      'City of Buda Final Reinspection',
      'City of Buda Foundation Inspection',
      'City of Buda Foundation Reinspection',
      'City of Buda Frame Inspection',
      'City of Buda Frame Re-inspection',
      'City of Buda Gas Inspection',
      'City of Buda Gas Reinspection',
      'City of Buda Inspection',
      'City of Buda Meter Reinspection',
      'City of Buda Plumbing Rough Inspection',
      'City of Buda Plumbing Rough Reinspection',
      'City of Buda Reinspection',
      'City of Buda Sewer Reinspection',
      'City of Buda Slab Ground - UFER',
      'City of Buda Wallboard Inspection',
      'City of Buda Wallboard Reinspection',
      'City of Buda Water and Sewer Inspection',
      'Clark Wilson Interior Elevation Inspection',
      'Clark Wilson Interior Elevation Reinspection',
      'Code Enforcement',
      'Colony MUD Compliance Drive Thru',
      'Colony MUD Compliance Inspection',
      'Commercial Plan Review',
      'Compliance Drive Through Inspection',
      'Concrete Placement Inspection',
      'Contractor Draw',
      'Copper Inspection',
      'Copper Reinspection',
      'Customer Service Inspection',
      'Customer Service Reinspection',
      'Cylinder Pickup',
      'D.R. Horton Inspection 1',
      'D.R. Horton Inspection 2',
      'D.R. Horton Inspection 3',
      'Driveway Inspection',
      'Driveway Reinspection',
      'ECAD Audit',
      'Eaglewood Interior Elevation Inspection',
      'Electrical Meter Inspection',
      'Electrical Meter Reinspection',
      'Electrical Rough Inspection',
      'Electrical Rough Reinspection',
      'Elevation and Notation Inspection (Ryland San Antonio)',
      'Energy Diagnostic Testing',
      'Energy Final Full Test',
      'Energy Inspection',
      'Energy Inspection COA',
      'Energy Reinspection',
      'Energy Reinspection COA',
      'Engineers Letter Inspection',
      'Engineers Letter Reinspection',
      'Engineers Letter Verification Inspection',
      'Erosion Control Inspection',
      'Existing Home Energy Audit',
      'FHA Mortgage Inspection',
      'FHA Reinspection',
      'Final Electrical Inspection',
      'Final Electrical Reinspection',
      'Final Electrical-Plumbing Inspection',
      'Final Electrical-Plumbing Reinspection',
      'Final Electrical/Meter Inspection',
      'Final Energy Inspection',
      'Final Energy Reinspection',
      'Final Flatwork Inspection',
      'Final Flatwork Reinspection',
      'Final Gas Inspection',
      'Final Gas Reinspection',
      'Final Grade Inspection',
      'Final Grade Reinspection',
      'Final Grade Reinspection - Ryland',
      'Final Inspection',
      'Final Landscape Inspection',
      'Final Mechanical Inspection',
      'Final Mechanical Reinspection',
      'Final Mechanical-Electrical Inspection',
      'Final Mechanical-Electrical Reinspection',
      'Final Mechanical-Electrical-Plumbing Inspection',
      'Final Mechanical-Electrical-Plumbing Reinspection',
      'Final Plumbing Inspection',
      'Final Plumbing Reinspection',
      'Final Reinspection',
      'Fire Proofing-Caulking-Penetration Inspection',
      'Fire Proofing-Caulking-Penetration Reinspection',
      'Fire Protection Inspection',
      'Fire Rated Soffits Inspection',
      'Fire Rated Soffits Reinspection',
      'Firewall Inspection',
      'Firewall Reinspection',
      'Flashing And Drainage Plane Inspection',
      'Flashing And Drainage Plane Reinspection',
      'Flashing Inspection',
      'Flashing Reinspection',
      'Foundation Pre-pour Inspection - AD',
      'Foundation Pre-pour Inspection - ATS Designed',
      'Foundation Pre-pour Inspection - NAD',
      'Foundation Pre-pour Inspection - Non ATS Designed',
      'Foundation Pre-pour Reinspection - AD',
      'Foundation Pre-pour Reinspection - ATS Designed',
      'Foundation Pre-pour Reinspection - NAD',
      'Foundation Pre-pour Reinspection - non ATS Designed',
      'Frame Inspection',
      'Frame Inspection with Certification Letter',
      'Frame Mapping',
      'Frame Reinspection',
      'Frame-Electrical Inspection',
      'Frame-Electrical Reinspection',
      'Frame-Mechanical Inspection',
      'Frame-Mechanical Reinspection',
      'Frame-Mechanical-Electrical Inspection',
      'Frame-Mechanical-Electrical Reinspection',
      'Frame-Mechanical-Electrical-Plumbing Inspection',
      'Frame-Mechanical-Electrical-Plumbing Reinspection',
      'Frame-Plumbing Inspection',
      'Frame-Plumbing Reinspection',
      'Gas Inspection',
      'Gas Reinspection',
      'Gehan Interior Elevation Inspection',
      'Gehan Interior Elevation Reinspection',
      'Grease Trap Inspection',
      'Grease Trap Reinspection',
      'Green Builder Verification 1 Inspection',
      'Green Builder Verification 1 Reinspection',
      'Green Builder Verification 2 Inspection',
      'Green Builder Verification 2 Reinspection',
      'HBW Final Grade Inspection',
      'HBW Final Inspection',
      'HBW TRCC Final Inspection',
      'HBW TRCC Final Reinspection',
      'Hammond Interior Elevation Inspection',
      'Home Buyer Walk Through Inspection',
      'Home Buyer Walk Through Inspection (DR Horton)',
      'Home Buyer Walk Through Inspection No. 2',
      'Home of TX Final Grade Inspection',
      'Home of TX Final Grade Reinspection',
      'Home of TX Stage 2 Inspection',
      'Home of TX Stage 2 Reinspection',
      'Home of TX Stage 3 Inspection',
      'Horizon View Homes Final QA',
      'House Wrap And Window Install Inspection',
      'House Wrap And Window Install Reinspection',
      'Ideal Custom Homes Interior Elevation Inspection',
      'Ideal Custom Homes Interior Elevation Reinspection',
      'Inspection',
      'Insulation Inspection',
      'Insulation Reinspection',
      'Interior Elevation Inspection',
      'Interior Elevation Reinspection',
      'Irrigation Inspection',
      'Irrigation Reinspection',
      'KB Home Final Inspection',
      'KB Home Final Reinspection',
      'Kimball Hill SA Final Inspection',
      'Layout Inspection',
      'Layout Reinspection',
      'Legacy Final Grade Inspection',
      'Legacy Final Grade Reinspection',
      'Legacy Interior Elevation Inspection',
      'Lexor Interior Elevation Inspection',
      'Lights On Inspection',
      'Mainstreet Final Grade Inspection',
      'Mainstreet Final Grade Reinspection',
      'Mainstreet Interior Elevation Inspection',
      'Mainstreet Interior Elevation Reinspection',
      'Mechanical Inspection',
      'Mechanical Reinspection',
      'Mechanical, Electrical and/or Plumbing Inspection',
      'Mechanical, Electrical and/or Plumbing Reinspection',
      'Meeting',
      'Megatel Interior Elevation Inspection',
      'Mercedes Interior Elevation Inspection',
      'Mercedes Interior Elevation Reinspection',
      'Meritage Interior Elevation Inspection',
      'Meritage Interior Elevation Reinspection',
      'Meter Inspection',
      'Military Inspection',
      'Mold Inspection',
      'Mold Reinspection',
      'Mold Stage 1',
      'Mold Stage 2',
      'Morrison Interior Elevation Inspection',
      'Morrison Interior Elevation Reinspection',
      'NGBS Final Inspection',
      'NGBS Final Reinspection',
      'NGBS Inspection',
      'NGBS Rough Inspection',
      'NGBS Rough Reinspection',
      'PR/Water/Sewer Inspection',
      'Pacesetter Interior Elevation Inspection',
      'Pacesetter Interior Elevation Reinspection',
      'Photographic Inspection',
      'Plan Review',
      'Plumbing Rough Inspection',
      'Plumbing Rough Reinspection',
      'Plumbing Topout Inspection',
      'Plumbing Topout Reinspection',
      'Post Sheathing Inspection',
      'Pre-pour Flatwork Inspection',
      'Pre-pour Flatwork Reinspection',
      'Pre-walk Through Inspection',
      'Prelath Waterproofing Inspection',
      'Prelath Waterproofing Reinspection',
      'Prominence Interior Elevation Inspection',
      'Prominence Interior Elevation Reinspection',
      'Property Assessment Inspection',
      'Property Assessment Reinspection',
      'Quality Assurance Inspection',
      'Quality Assurance Reinspection',
      'RWC Final Grade Inspection',
      'RWC Final Grade Reinspection',
      'RWC Stage 3 Inspection',
      'Re-frame Inspection',
      'Residential Finals/C/O Inspection',
      'Residential Finals/C/O Reinspection',
      'Residential Plan Review',
      'Reytex Interior Elevation Inspection',
      'Rialto Interior Elevation Inspection',
      'Rialto Interior Elevation Reinspection',
      'Rivendale Building Envelope Inspection',
      'Rivendale Final Inspection',
      'Rivendale Final Reinspection',
      'Rivendale Prelath Inspection',
      'Roof Final Inspection',
      'Roof Final Reinspection',
      'Roof Rough Inspection',
      'Roof Rough Reinspection',
      'Ryland Final Grade Inspection',
      'Ryland Final Grade Reinspection',
      'Ryland Frame Inspection (San Antonio)',
      'Ryland Interior Elevation Inspection',
      'Ryland Interior Elevation Reinspection',
      'Scott Custom Homes Interior Elevation Inspection',
      'Scott Custom Homes Interior Elevation Reinspection',
      'Scott Felder Interior Elevation Inspection',
      'Scott Felder Interior Elevation Reinspection',
      'Scott Homes Interior Elevation Inspection',
      'Sewer Inspection',
      'Sewer Reinspection',
      'Sheathing Inspection',
      'Sheathing Reinspection',
      'Sheetrock Inspection - Wilshire Homes',
      'Sheetrock Reinspection - Wilshire Homes',
      'Short Term Rental Inspection',
      'Sierra Classic Homes Interior Elevation Inspection',
      'Sierra Classic Homes Quality Inspection Final',
      'Sierra Classic Homes Quality Inspection Frame',
      'Site Inspection',
      'Site Reinspection',
      'Sitterle Homes Interior Elevation Inspection',
      'Slab Ground UFER Inspection',
      'Slab Ground UFER Reinspection',
      'Soil Pick-up and Testing',
      'Steiner Ranch Final Inspection',
      'Steiner Ranch Final Reinspection',
      'Stress Inspection',
      'Stress Reinspection',
      'StrucSure Final Grade Inspection',
      'StrucSure Final Grade Reinspection',
      'StrucSure Final Inspection',
      'StrucSure Final Reinspection',
      'StrucSure Foundation Pre-Pour Inspection',
      'StrucSure Foundation Pre-Pour Reinspection',
      'StrucSure Frame Inspection',
      'StrucSure Frame Reinspection',
      'Stucco and Lath Inspection',
      'Stucco and Lath Reinspection',
      'Sun-coast Post-Tension Inspection',
      'T-Pole Inspection',
      'TRCC Bonded Builder Final Grade Inspection',
      'TRCC Bonded Builder Final Inspection',
      'TRCC Bonded Builder Final Reinspection',
      'TRCC Bonded Builder Frame Inspection',
      'TRCC Bonded Builder Frame Reinspection',
      'TRCC Final Inspection',
      'TRCC Final Reinspection',
      'TRCC Foundation Inspection',
      'TRCC Foundation Reinspection',
      'TRCC Frame Inspection',
      'TRCC Frame Reinspection',
      'Tella Firma Rough Plumbing Stage',
      'Temporary Power Inspection',
      'Temporary Power Reinspection',
      'Texas Classic Homes Interior Elevation Inspection',
      'Texas Classic Homes Interior Elevation Reinspection',
      'Thermal Bypass Inspection',
      'Thermal Bypass Reinspection',
      'Thermal bypass Inspection',
      'Tilson Interior Elevation Inspection',
      'Tilson Interior Elevation Reinspection',
      'Treaty Oaks Interior Elevation Inspection',
      'Treaty Oaks Interior Elevation Reinspection',
      'Underground Electrical Inspection',
      'Vintage Estate Interior Elevation Inspection',
      'Wall Tie - Masonry Inspection',
      'Wallboard Inspection',
      'Wallboard Reinspection',
      'Water Line Inspection',
      'Water Line Reinspection',
      'Water Softener Inspection',
      'Water-Sewer Inspection',
      'Water-Sewer Reinspection',
      'Waterford Boatdock Inspection',
      'Weatherization Test In Inspection',
      'Weatherization Test Out Inspection',
      'Weatherization Test Out Reinspection',
      'Welding Inspection',
      'Windbrace Inspection',
      'Windbrace Reinspection',
      'Window Tape Inspection',
      'Window Tape Reinspection',
      'Yardline Inspection',
      'Yardline Reinspection'
    ],
    INVOICE_STATUSES: [
      'Created',
      'Ignored',
      'Pending'
    ],
    INSPECTORS: [
      'AJ Rubio',
      'Alex Hunt',
      'Alex Watson',
      'Andrew Evans',
      'Anibal Serna',
      'Anthony Garcia',
      'Antonio Cisneros',
      'Ariana Estrada',
      'Ariana Ramirez',
      'Art Contreras',
      'Audie Farmer',
      'Ben Jessamine',
      'Bert Ward',
      'Bill King',
      'Bob Rogers',
      'Bradly Montgomery',
      'CJ Marincus',
      'CT Loyd',
      'Cancelled',
      'Candice Brown',
      'Carl Meuth',
      'Carl Phinney',
      'Carl Winn',
      'Cesar Saldivar',
      'Chad Mayes',
      'Chara Janysek',
      'Chara Jaysek',
      'Chris Little',
      'Chris Smith',
      'Completed',
      'Dakota Voorhis',
      'Dale Jones',
      'Daniel Bricker',
      'Daniel Dillender',
      'Danny Batts',
      'David Brasich',
      'David Degante',
      'David Rodriguez',
      'David Velasquez',
      'David Walentynowicz',
      'David Yount',
      'David walentynowicz',
      'Dearl Croft',
      'Dennis Rodriguez',
      'Dondi Atwell',
      'Doug McAfee',
      'Dustin Mills',
      'Eric Knapp',
      'Fox Energy',
      'Fred Janis',
      'G. R. Breehl',
      'Garrett Johnson',
      'Garrison McAfee',
      'Gary McFarlane',
      'George Breehl',
      'Guy Brown',
      'Humberto Chavero',
      'Incomplete',
      'J Wright',
      'Jaime Lanka',
      'James Dorr',
      'Jason Cottongame',
      'Jason Hall',
      'Jeff Calhoun',
      'Jeffrey Frazier',
      'Jeffrey Landis',
      'Jesus Rosales',
      'Jim Drewery',
      'Jim Goes',
      'Jim White',
      'Jim Williams',
      'Joe Emerson',
      'Joe Meuth',
      'John Maldonado',
      'John Owens',
      'John Shepherd',
      'John Speights',
      'John Utterback',
      'Jose Espinoza',
      'Josh Jordan',
      'Juan Perez',
      'Julian Morton',
      'Justin Bauer',
      'Justin Mayfield',
      'Kelly Bellview',
      'Ken Kilcoin',
      'Kevin Girman',
      'Logan Lindsey',
      'Lucy Estrada',
      'Luis Franco',
      'Luis Hernandez',
      'Mario Perez',
      'Mark Medina',
      'Marlin Hartmann',
      'Matt Sist',
      'Mauricio Gutierrez',
      'Michael Borden',
      'Michael Davis',
      'Michael Freier',
      'Michael Gleason',
      'Michael Smith',
      'Mike Harral',
      'Mike Matustik',
      'Nathan White',
      'Ned Fisher',
      'Nick Janysek',
      'Noah Giltner',
      'Nycholas White',
      'Oscar Chavarria',
      'Otis Justice',
      'Passed',
      'Plumbing Inspector',
      'Rainer Bergmann',
      'Raul Gutierrez',
      'Rich Emerson',
      'Richard Emerso',
      'Richard Emerson',
      'Rick Roberts',
      'Ricky Barba',
      'Robert Adams',
      'Rod Cox',
      'Roy Howard',
      'Royce Groff',
      'Ryan Dodson',
      'Shandi Whited',
      'Stacey Webb',
      'Steve Bennefield',
      'Steve Hampton',
      'Steve Van Patten',
      'Steven Gonzales',
      'Treva Rowland',
      'Unknown',
      'Wallace Britton',
      'Wes Buckner',
      'Wes Tolle',
      'Wesley Torio',
      'Will Guidry'
    ],
    SCHEDULERS: [
      'Aliath Chavez',
      'Amanda Rogers',
      'Amber Warren',
      'Ana Espinoza',
      'Andrew Evans',
      'Angela Frazier',
      'Angeli Camenforte',
      'Ann Strouse',
      'April Pate',
      'Ariana Estrada',
      'Ariana Gonzalez',
      'Ariana Ramirez',
      'Ashlea Simmons',
      'Bradly Montgomery',
      'Brenna Hayes',
      'Brenna Killam',
      'Bridget Westerman',
      'Bronwynn Ollington',
      'CT Loyd',
      'Caley Thomas',
      'Candice Brown',
      'Carl Meuth',
      'Carrie Coss',
      'Chara Janysek',
      'Chris Smith',
      'Christian Copeland',
      'Christina Buckner',
      'Courtney Richardson',
      'Danny Batts',
      'Darlene Elkins',
      'Dave Walentynowicz',
      'David Rodriguez',
      'Dawn Knebel',
      'Dondi Atwell',
      'Eilish Thomas',
      'Elisabeth Boudreaux',
      'Emily Long',
      'Eric Knapp',
      'Felicia Crunk',
      'George Breehl',
      'Guy Brown',
      'Holly Shipwash',
      'Ivy Negron',
      'Jaime Lanka',
      'James Dorr',
      'Jason Hall',
      'Jeanette Gonzalez',
      'Jennifer Loupe',
      'Jennifer Phillips',
      'Jim Drewery',
      'Jim Williams',
      'Joan Portillo',
      'Jose Espinoza',
      'Josh Jordan',
      'Julia Bentura',
      'Julia Molle',
      'Julia Sliva',
      'Julian Morton',
      'Kacy Garza',
      'Kathryn Cano',
      'Kaye Loyd',
      'Kelly Bellview',
      'Ken Kilcoin',
      'Kourtnie Doherty',
      'Krista Hazlett',
      'Kristi Helton',
      'Lauren Coddington',
      'Linda Brown',
      'Lisa Boatman',
      'Liz Miller',
      'Lucy Estrada',
      'Lucy Zamora',
      'Lupita Garcia',
      'M J Pentecost',
      'Maria Pimentel',
      'Mauricio Gutierrez',
      'Megan Limon',
      'Megan Rodriguez',
      'Melissa Rodriguez',
      'Michael Borden',
      'Michael Gleason',
      'Michelle Frazier',
      'Monica Sanchez',
      'Olivia Nulton',
      'Petronia Tete',
      'Rhianna Powell',
      'Riannon Teague',
      'Richard Emerson',
      'Rick Roberts',
      'Robert Adams',
      'Ruth Council',
      'Sabina Reynoso',
      'Seth Wood',
      'Sharon Sargent',
      'Shelby Vanuum',
      'Stephanie Guzman',
      'Steve Hampton',
      'Steven Gonzales',
      'Tamara Woodard',
      'Thea Goertzen',
      'Thelma Faglie',
      'Tiffany Neece',
      'Tina Cox',
      'Treva Rowland',
      'Will Guidry'
    ],
    CITIES: [
      'Acton',
      'Adkins',
      'Alamo Heights',
      'Aledo',
      'Alice',
      'Allen',
      'Alvarado',
      'Ammannsville',
      'Andice',
      'Anna',
      'Argyle',
      'Arlington',
      'Art',
      'Atascosa',
      'Athens',
      'Atlanta',
      'Aubrey',
      'Austin',
      'Azle',
      'Baltimore',
      'Bandera',
      'Bartlett',
      'Bastrop',
      'Bay City',
      'Bee Cave',
      'Beeville',
      'Bells',
      'Bellville',
      'Belmont',
      'Belton',
      'Bend',
      'Berclair',
      'Bergheim',
      'Bertram',
      'Big Foot',
      'Blanco',
      'Blue',
      'Boerne',
      'Bonham',
      'Boyd',
      'Brady',
      'Bremond',
      'Brenham',
      'Briarcliff',
      'Bridgeport',
      'Briggs',
      'Brock',
      'Brooksmith',
      'Bruceville-Eddy',
      'Bryan',
      'Buchanan Dam',
      'Buckholts',
      'Buda',
      'Bulverde',
      'Burleson',
      'Burlington',
      'Burnet',
      'Burton',
      'Caddo Mills',
      'Caldwell',
      'Cameron',
      'Campwood',
      'Canton',
      'Canyon Lake',
      'Carrollton',
      'Castroville ',
      'Cat Springs',
      'Cedar Creek',
      'Cedar Hills',
      'Cedar Park',
      'Celeste',
      'Celina',
      'Centerpoint',
      'Centerville',
      'Chappell Hill',
      'Charlotte',
      'Cherokee',
      'Chico',
      'Chilton',
      'China Grove',
      'China Spring',
      'Cibolo',
      'Cleburne',
      'College Station',
      'Collinsville',
      'Columbus',
      'Combine',
      'Comfort',
      'Concan',
      'Converse',
      'Copeland',
      'Copperas Cove',
      'Corpus Christi',
      'Corsicana',
      'Cost',
      'Cottonwood Shores',
      'Coupland',
      'Crandall',
      'Crawford',
      'Creedmoor',
      'Cresson',
      'Cross Plains',
      'Crowley',
      'Cuero',
      'Cypress',
      'D Hanis',
      'Dale',
      'Dallas',
      'Decatur',
      'Del Valle',
      'Denison',
      'Dennis',
      'Denton',
      'Denver',
      'Desoto',
      'Devine',
      'Dickinson',
      'Dilley',
      'Dime Box',
      'Ding Dong',
      'Dodd City',
      'Doss',
      'Driftwood',
      'Dripping Springs',
      'Eagle Pass',
      'Early',
      'East Bernard',
      'Edgewood',
      'Edinburg',
      'Edna',
      'Elgin',
      'Ellinger',
      'Elmendorf',
      'Ennis',
      'Euless',
      'Evant',
      'Exton',
      'Fair Oaks Ranch',
      'Fairfield',
      'Falls City',
      'Fannin',
      'Farmersville',
      'Fate',
      'Fayetteville',
      'Ferris',
      'Fields Store',
      'Fischer',
      'Flatonia',
      'Florence',
      'Floresville',
      'Forney',
      'Fort Hood',
      'Fort Worth',
      'Fredericksburg',
      'Frisco',
      'Frost',
      'Ft. Sam Houston',
      'Ft. Worth',
      'Gainesville',
      'Garden Ridge',
      'Garfield',
      'Garland',
      'Gatesville',
      'Gause',
      'George West',
      'Georgetown',
      'Gibtown',
      'Giddings',
      'Glenn Heights',
      'Godley',
      'Goldthwaite',
      'Goliad',
      'Gonzales',
      'Graford',
      'Granbury',
      'Grand Prairie',
      'Grandview',
      'Granger',
      'Granite Shoals',
      'Greenville',
      'Gruene',
      'Gunter',
      'Halletsville',
      'Hallettsville',
      'Haltom City',
      'Harker Heights',
      'Harper',
      'Harwood',
      'Haslet',
      'Hays',
      'Heartland',
      'Heath',
      'Helotes',
      'Henly',
      'Hickory Creek',
      'Highland Haven',
      'Holland',
      'Hollywood Park',
      'Hondo',
      'Horseshoe Bay',
      'Horseshoe Bay ETJ',
      'Houston',
      'Howe',
      'Hudson Bend',
      'Humble',
      'Hunt',
      'Huntsville',
      'Hutchins',
      'Hutto',
      'Incline Village',
      'Inez',
      'Ingleside',
      'Ingram',
      'Irving',
      'Jarrell',
      'Johnson City',
      'Jonestown',
      'Joshua',
      'Jourdanton',
      'Junction',
      'Karnes City',
      'Katy',
      'Keene',
      'Kemp',
      'Kempner',
      'Kendalia',
      'Kenedy',
      'Kennedale',
      'Kerrville',
      'Killeen',
      'King of Prussia',
      'Kingsbury',
      'Kingsland',
      'Kingwood',
      'Krum',
      'Kyle',
      'La Grange',
      'La Pryor',
      'La Vernia',
      'Lacoste',
      'Lago Vista',
      'Lake Brownwood',
      'Lakehills',
      'Lakehurst',
      'Lakeway',
      'Lampasas',
      'Laredo',
      'Lavon',
      'League City',
      'Leakey',
      'Leander',
      'Ledbetter',
      'Leesville',
      'Leon Springs',
      'Leon Valley',
      'Lewisville',
      'Lexington',
      'Liberty Hill',
      'Lincoln',
      'Lipan',
      'Little Elm',
      'Little River Academy',
      'Live Oak',
      'Llano',
      'Lockhart',
      'Lometa',
      'London',
      'Lone Grove',
      'Longview',
      'Lorena',
      'Lott',
      'Luling',
      'Lytle',
      'Lytton Springs',
      'Magnolia',
      'Manchaca',
      'Manor',
      'Mansfield',
      'Marble Falls',
      'Marion',
      'Marlin',
      'Martindale',
      'Mason',
      'Maxwell',
      'McDade',
      'McGregor',
      'McKinney',
      'McLean',
      'McQueeney',
      'Meadowlake',
      'Medina',
      'Medina Lake',
      'Melissa',
      'Menard',
      'Mesquite',
      'Mico',
      'Midland',
      'Midlothian',
      'Milano',
      'Millsap',
      'Mineral Wells',
      'Missouri City',
      'Montgomery',
      'Moody',
      'Moore',
      'Moulton',
      'Mountain City',
      'Mountain Home',
      'Muldoon',
      'Mullin',
      'Mustang Ridge',
      'Natalia',
      'New Braunfels',
      'Niederwald',
      'Nixon',
      'Nolanville',
      'Nordheim',
      'Northlake',
      'Nursery',
      'Oak Hill',
      'Oak Point',
      'Oakalla',
      'Oatmeal',
      'Olmos Park',
      'Orlando',
      'Paige',
      'Palestine',
      'Palmer',
      'Panna Maria',
      'Pantego',
      'Paradise',
      'Pasadena',
      'Pettus',
      'Pflugerville',
      'Pilot Point',
      'Pipe Creek',
      'Pleasanton',
      'Plum',
      'Point Venture',
      'Poolville',
      'Port Aransas',
      'Port OConnor',
      'Poteet',
      'Pottsboro',
      'Prairie Lea',
      'Princeton',
      'Prosper',
      'Providence Village',
      'Raleigh',
      'Red Oak',
      'Red Rock',
      'Refugio',
      'Rendon',
      'Reno',
      'Rhome',
      'Richardson',
      'Richland Springs',
      'Richmond',
      'Rio Frio',
      'Rio Medina',
      'Robstown',
      'Rochelle',
      'Rockdale',
      'Rockport',
      'Rockwall',
      'Rogers',
      'Rollingwood',
      'Rosanky',
      'Rosebud',
      'Rosenberg',
      'Rosharon',
      'Round Mountain',
      'Round Rock',
      'Round Top',
      'Rowlett',
      'Royse City',
      'Sabinal',
      'Sachse',
      'Saginaw',
      'Saint Hedwig',
      'Salado',
      'San Antonio',
      'San Leanna',
      'San Marcos',
      'San Saba',
      'Sandia',
      'Sanger',
      'Santo',
      'Sattler',
      'Schertz',
      'Schulenburg',
      'Seadrift',
      'Seagoville',
      'Sealy',
      'Seguin',
      'Selma',
      'Serbin',
      'Seven Oaks Sect 4',
      'Shavano Park',
      'Sherman',
      'Shiner',
      'Sisterdale',
      'Smiley',
      'Smithville',
      'Smithwick',
      'Somerset',
      'Sonora',
      'Southlake',
      'Spicewood',
      'Spring',
      'Spring Branch',
      'Springtown',
      'St. Hedwig',
      'Staples',
      'Startzville',
      'Stockdale',
      'Stonewall',
      'Strawn',
      'Sugar Land',
      'Summerfield',
      'Sun City',
      'Sunrise Beach Village',
      'Sunset Valley',
      'Sweet Home',
      'Tanglewood',
      'Tarpley',
      'Taylor',
      'Tempe',
      'Temple',
      'Terrell',
      'Terrell Hills',
      'Texarkana',
      'The Hills',
      'The Woodlands',
      'Thorndale',
      'Thornton',
      'Thrall',
      'Thrall ETJ',
      'Three Rivers',
      'Tilden',
      'Tolar',
      'Tomball',
      'Tow',
      'Trenton',
      'Trophy Club',
      'Troy',
      'Tyler',
      'Uhland',
      'Universal City',
      'University Park',
      'Upper Marlboro',
      'Utopia',
      'Uvalde',
      'Valley Forge',
      'Van Alstyne',
      'Vanderpool',
      'Venus',
      'Victoria',
      'Village of Bear Creek',
      'Volente',
      'Von Ormy',
      'Waco',
      'Waelder',
      'Walburg',
      'Waring',
      'Waterford on Lake Travis',
      'Watson',
      'Waxahachie',
      'Weatherford',
      'Webbervile',
      'Weir',
      'West Point',
      'Westhoff',
      'Westlake',
      'Westlake Hills',
      'Weston Lakes',
      'White Settlement',
      'Whitesboro',
      'Willow City',
      'Wimberley',
      'Windcrest',
      'Woodcreek',
      'Woodway',
      'Wylie',
      'Yancey',
      'Yoakum',
      'Yorktown',
      'Zorn'
    ],
    STATES: [
      { value: 'CO', label: 'Colorado' },
      { value: 'FL', label: 'Florida' },
      { value: 'GA', label: 'Georgia' },
      { value: 'MD', label: 'Maryland' },
      { value: 'NV', label: 'Nevada' },
      { value: 'NC', label: 'North Carolina' },
      { value: 'PA', label: 'Pennsylvania' },
      { value: 'TX', label: 'Texas' },
      { value: 'VA', label: 'Virginia' },
    ],
  }
}

export default constants
